import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { CustodyAccountFacade } from "@modules/+new/custody_account/domain/+state/custody_account.facade";
import { CUSTODY_ACCOUNT_OPENING_MODAL } from "@modules/+new/custody_account/domain/entities/custody_account.model";
import { CustodyAccountOpeningStep } from "@modules/+new/custody_account/features/cam-modal/cam-modal.model";
import { EMPTY, Observable } from "rxjs";

@Component({
	selector: "custody-account-banner",
	templateUrl: "./custody-account-banner.component.html",
	styleUrls: ["./custody-account-banner.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class CustodyAccountBannerComponent implements OnInit {
	public showCABanner$: Observable<boolean> = EMPTY;
	public custodyAccountOpening: string = `${CUSTODY_ACCOUNT_OPENING_MODAL}/${CustodyAccountOpeningStep.PRESCREEN}`;

	constructor(
		private readonly custodyAccountService: CustodyAccountFacade,
		private readonly router: Router
	) {}

	public ngOnInit(): void {
		this.showCABanner$ = this.custodyAccountService.checkEligibility$();
	}

	public startCustodyAccountOpening(modal: string): void {
		this.router.navigate(
			[
				"/home",
				{
					outlets: {
						[CUSTODY_ACCOUNT_OPENING_MODAL]: modal
					}
				}
			],
			{ skipLocationChange: true }
		);
	}
}
